module.exports = __webpack_public_path__ + "static/media/Wordmark.fe4083f7.svg";